<app-push-aside-content [showAside]="showLeftNav" (overlayClose)="showLeftNav = false" asideWidth="280px">
  <app-aside-content>
    <app-left-nav></app-left-nav>
  </app-aside-content>
  <app-main-content>
    <app-header [actionLeft]="appHeaderLeftAction"></app-header>
    <!--<app-sub-header></app-sub-header>--> <!-- TODO: Fix Me -->
    <app-banner-msg></app-banner-msg>
    <div class="resources-container">
      <div>
        <h1 auto="resHeader" >Resources</h1>
        <ul class="styleless">
          <li>
            <div auto="res-infocus-dwnld" (click)="onDownloadAssetClick('/eprove-strategies/user-guides/guidebook.pdf')">
              <a>The inFocus Guide</a>
              <i class="fa fa-fw fa-download"></i>
            </div>
          </li>
          <li>
            <div auto="res-faq-dwnld" (click)="onDownloadAssetClick('/eprove-strategies/user-guides/faqs.pdf')">
              <a>Frequently Asked Questions</a>
              <i class="fa fa-fw fa-download"></i>
            </div>
          </li>
          <li>
            <div auto="res-glossary-dwnld" (click)="onDownloadAssetClick('/eprove-strategies/user-guides/glossary.pdf')">
              <a>Glossary</a>
              <i class="fa fa-fw fa-download"></i>
            </div>
          </li>
          <li>
            <div auto="res-tagging-dwnld" (click)="onDownloadAssetClick('/eprove-strategies/user-guides/tags-explained.pdf')">
              <a>Tagging Explained</a>
              <i class="fa fa-fw fa-download"></i>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </app-main-content>
</app-push-aside-content>
